module.exports = __webpack_public_path__ + "jaibiffb.f418350944874cda2388.jpg";


//////////////////
// WEBPACK FOOTER
// /builds/cp/frap/t3/planer/src/assets/img/jaibiffb.jpg
// module id = ../../../../../src/assets/img/jaibiffb.jpg
// module chunks = main